import { Component, forwardRef } from '@angular/core';
import { UserActionBaseComponent } from '../userAction-base.component';
import { LoginService } from 'app/Services/login.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslatedText } from 'app/Model/ui/TranslatedText';
import {Macro} from "../../../../Model/ui/Macro";

@Component({
    selector: 'userAction-consolidateDubSupplierPids',
    templateUrl: 'userAction-consolidateDubSupplierPids.component.html',
    providers: [
        {
            provide: UserActionBaseComponent,
            useExisting: forwardRef(() => UserActionConsolidateDubSupplierPidsComponent)
        }
    ],
    standalone: false
})
export class UserActionConsolidateDubSupplierPidsComponent extends UserActionBaseComponent {
    selectedType: string = 'SUPPLIER_PID';
    types: TranslatedText[] = [];

    constructor(
        public loginService: LoginService,
        public macroService: MacroService,
        public translate: TranslateService
    ) {
        super(loginService, macroService);
        this.types.push(new TranslatedText('SUPPLIER_PID', this.translate.instant('SUPPLIER_PID')));
        this.types.push(new TranslatedText('SUPPLIER_ALT_PID', this.translate.instant('SUPPLIER_ALT_PID')));
        this.types.push(new TranslatedText('INTERNATIONAL_PID', this.translate.instant('INTERNATIONAL_PID')));
    }

    parseParameter(parameter: string) {
        if (!parameter)
            return;
        
        try {
            const parsed = JSON.parse(parameter);
            this.selectedType = parsed.Type;
        } catch (error) {
            console.error('Invalid JSON string provided:', error);
        }
    }

  public getActionId(macro: Macro): string {
    return `ConsolidateDubSupplierPids(${this.selectedType})`;
  }
  
    createParameterStringAsJsonString(): string {
        return JSON.stringify({ Type: this.selectedType });
    }
}
